const SITE_URL = 'https://nocontextgames.de'
const SITE_NAME = 'No Context Games'

const routeGames = Object.freeze({
  game: 'glitch',
  join: 'glitch',
  host: 'glitch',
  player: 'glitch',
  'pitch-game': 'pitch',
  'pitch-join': 'pitch',
  'pitch-host': 'pitch',
  'pitch-player': 'pitch',
  'heist-game': 'heist',
  'heist-join': 'heist',
  'heist-host': 'heist',
  'heist-player': 'heist',
  'alibi-game': 'alibi',
  'alibi-join': 'alibi',
  'alibi-host': 'alibi',
  'alibi-player': 'alibi',
  'drawback-game': 'drawback',
  'drawback-join': 'drawback',
  'drawback-host': 'drawback',
  'drawback-player': 'drawback',
  'dead-air-game': 'deadAir',
  'dead-air-join': 'deadAir',
  'dead-air-host': 'deadAir',
  'dead-air-player': 'deadAir',
  'no-offense-game': 'noOffense',
  'no-offense-join': 'noOffense',
  'no-offense-host': 'noOffense',
  'no-offense-player': 'noOffense',
  'secret-menu-game': 'secretMenu',
  'secret-menu-join': 'secretMenu',
  'secret-menu-host': 'secretMenu',
  'secret-menu-player': 'secretMenu',
  'bad-advice-game': 'badAdvice',
  'bad-advice-join': 'badAdvice',
  'bad-advice-host': 'badAdvice',
  'bad-advice-player': 'badAdvice',
  'unsent-game': 'unsent',
  'unsent-join': 'unsent',
  'unsent-host': 'unsent',
  'unsent-player': 'unsent',
  'open-tabs-game': 'openTabs',
  'open-tabs-join': 'openTabs',
  'open-tabs-host': 'openTabs',
  'open-tabs-player': 'openTabs',
  'side-quest-game': 'sideQuest',
  'side-quest-join': 'sideQuest',
  'side-quest-host': 'sideQuest',
  'side-quest-player': 'sideQuest',
  'provenance-game': 'provenance',
  'provenance-join': 'provenance',
  'provenance-host': 'provenance',
  'provenance-player': 'provenance',
  'say-more-game': 'sayMore',
  'say-more-join': 'sayMore',
  'say-more-host': 'sayMore',
  'say-more-player': 'sayMore',
  'receipts-game': 'receipts',
  'receipts-join': 'receipts',
  'receipts-host': 'receipts',
  'receipts-player': 'receipts',
})

const landingRoutes = new Set([
  'game',
  'pitch-game',
  'heist-game',
  'alibi-game',
  'drawback-game',
  'dead-air-game',
  'no-offense-game',
  'secret-menu-game',
  'bad-advice-game',
  'unsent-game',
  'open-tabs-game',
  'side-quest-game',
  'provenance-game',
  'say-more-game',
  'receipts-game',
])

const themeColors = Object.freeze({
  pitch: '#d9f24f',
  heist: '#10122b',
  alibi: '#f3bd26',
  drawback: '#caff3f',
  deadAir: '#ff5b35',
  noOffense: '#ff4f91',
  secretMenu: '#3a071d',
  badAdvice: '#0b0c0b',
  unsent: '#150d2e',
  openTabs: '#2854e8',
  sideQuest: '#ff714a',
  provenance: '#11182b',
  sayMore: '#f6f0e4',
  receipts: '#ee4b36',
  glitch: '#25175f',
})

function setMeta(selector, attribute, value) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    const [name, property] = selector.includes('[name=')
      ? [selector.match(/\[name="([^"]+)"/)?.[1], null]
      : [null, selector.match(/\[property="([^"]+)"/)?.[1]]
    if (name) element.setAttribute('name', name)
    if (property) element.setAttribute('property', property)
    document.head.append(element)
  }
  element.setAttribute(attribute, value)
}

function getPageCopy(route, t, language) {
  const german = language === 'de'
  const gameKey = routeGames[route.name]
  if (route.name === 'pack') {
    return {
      title: t('meta.title', { ns: 'pack' }),
      description: t('meta.description', { ns: 'pack' }),
      indexable: true,
    }
  }
  if (landingRoutes.has(route.name)) {
    const gameName = `${t(`catalog.${gameKey}.title`, { ns: 'pack' })} ${t(`catalog.${gameKey}.accent`, { ns: 'pack' })}`
    return {
      title: `${gameName} — ${german ? 'kostenloses Browser-Partyspiel' : 'free browser party game'}`,
      description: t(`catalog.${gameKey}.description`, { ns: 'pack' }),
      indexable: true,
    }
  }
  if (route.name === 'imprint') {
    return {
      title: `${german ? 'Impressum' : 'Legal notice'} | ${SITE_NAME}`,
      description: german ? 'Impressum und Anbieterinformationen von No Context Games.' : 'Legal notice and provider information for No Context Games.',
      indexable: true,
    }
  }
  if (route.name === 'privacy') {
    return {
      title: `${german ? 'Datenschutz' : 'Privacy policy'} | ${SITE_NAME}`,
      description: german ? 'Datenschutzerklärung von No Context Games.' : 'Privacy information for No Context Games.',
      indexable: true,
    }
  }
  if (route.name === 'pack-join' || route.name.endsWith('-join') || route.name === 'join') {
    return {
      title: `${german ? 'Raum beitreten' : 'Join a room'} | ${SITE_NAME}`,
      description: german ? 'Tritt mit deinem vierstelligen Code einem No Context Games Spielraum bei.' : 'Join a No Context Games room with your four-letter code.',
      indexable: false,
    }
  }
  if (gameKey) {
    const gameName = `${t(`catalog.${gameKey}.title`, { ns: 'pack' })} ${t(`catalog.${gameKey}.accent`, { ns: 'pack' })}`
    return {
      title: `${gameName} | ${SITE_NAME}`,
      description: t(`catalog.${gameKey}.description`, { ns: 'pack' }),
      indexable: false,
    }
  }
  return {
    title: `${german ? 'Seite nicht gefunden' : 'Page not found'} | ${SITE_NAME}`,
    description: german ? 'Diese Seite wurde nicht gefunden.' : 'This page could not be found.',
    indexable: false,
  }
}

function removeStaleStructuredData(canonicalUrl) {
  const element = document.getElementById('structured-data')
  if (!element) return
  if (!canonicalUrl) {
    element.remove()
    return
  }
  try {
    const schema = JSON.parse(element.textContent)
    const entries = Array.isArray(schema?.['@graph']) ? schema['@graph'] : [schema]
    const page = entries.find(({ '@type': type }) => type === 'WebPage' || type === 'CollectionPage')
    if (page?.url !== canonicalUrl) element.remove()
  } catch {
    element.remove()
  }
}

export function updatePageMetadata(route, t, resolvedLanguage) {
  const language = resolvedLanguage?.split('-')[0] === 'de' ? 'de' : 'en'
  const copy = getPageCopy(route, t, language)
  const gameKey = routeGames[route.name]
  const canonicalUrl = copy.indexable ? `${SITE_URL}${window.location.pathname === '/' ? '' : window.location.pathname}` : null
  const socialUrl = canonicalUrl ?? `${SITE_URL}/`
  const socialImage = `${SITE_URL}${gameKey === 'receipts' ? '/receipts-og.jpg' : '/og.png'}`
  const socialImageWidth = '1200'
  const socialImageHeight = gameKey === 'receipts' ? '675' : '630'
  const socialImageAlt = gameKey === 'receipts' ? 'RECEIPTS — Bring proof. Or make it up.' : 'No Context Games — colorful browser party games'

  document.title = copy.title
  document.documentElement.lang = language
  setMeta('meta[name="description"]', 'content', copy.description)
  setMeta('meta[name="robots"]', 'content', copy.indexable ? 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' : 'noindex, nofollow')
  setMeta('meta[name="theme-color"]', 'content', themeColors[gameKey] ?? '#f4eedf')
  setMeta('meta[property="og:title"]', 'content', copy.title)
  setMeta('meta[property="og:description"]', 'content', copy.description)
  setMeta('meta[property="og:url"]', 'content', socialUrl)
  setMeta('meta[property="og:locale"]', 'content', language === 'de' ? 'de_DE' : 'en_US')
  setMeta('meta[property="og:image"]', 'content', socialImage)
  setMeta('meta[property="og:image:width"]', 'content', socialImageWidth)
  setMeta('meta[property="og:image:height"]', 'content', socialImageHeight)
  setMeta('meta[property="og:image:alt"]', 'content', socialImageAlt)
  setMeta('meta[name="twitter:title"]', 'content', copy.title)
  setMeta('meta[name="twitter:description"]', 'content', copy.description)
  setMeta('meta[name="twitter:image"]', 'content', socialImage)
  setMeta('meta[name="twitter:image:alt"]', 'content', socialImageAlt)

  let canonical = document.head.querySelector('link[rel="canonical"]')
  if (!copy.indexable) {
    canonical?.remove()
  } else {
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.append(canonical)
    }
    canonical.href = canonicalUrl
  }
  removeStaleStructuredData(canonicalUrl)
}
